/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Body = void 0;

var react_1 = __importDefault(require("react"));

var name = 'Body';
exports.name = name;

var Body = function Body(_ref) {
  var Frame = _ref.Frame,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(_class, _react_1$default$Comp);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var onMount = this.props.onMount;

        if (onMount) {
          onMount();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            children = _this$props.children,
            classes = _this$props.classes,
            forwardRef = _this$props.forwardRef,
            fullScreen = _this$props.fullScreen,
            noHeader = _this$props.noHeader,
            noFooter = _this$props.noFooter,
            style = _this$props.style;
        console.log('Body.props', this.props);
        return react_1.default.createElement(Frame, {
          className: ['Body__container', classes === null || classes === void 0 ? void 0 : classes.container, classes === null || classes === void 0 ? void 0 : classes.fixed, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.maxWidth, !fullScreen), _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.noHeader, noHeader), _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.noFooter, noFooter), {
            'Body--full-screen': fullScreen
          }],
          ref: forwardRef,
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.container), style === null || style === void 0 ? void 0 : style.container)
        }, before, children, after);
      }
    }]);

    return _class;
  }(react_1.default.Component);
};

exports.Body = Body;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f;

  return {
    container: Object.assign({
      background: (_a = theme === null || theme === void 0 ? void 0 : theme.base) === null || _a === void 0 ? void 0 : _a.backgroundColor,
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      margin: '0 auto',
      '@media (max-width: 960px)': {
        flexDirection: 'column'
      },
      '@media (min-width: 961px)': {
        maxHeight: '100%'
      }
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.Body) === null || _b === void 0 ? void 0 : _b.container),
    fixed: Object.assign({
      bottom: (_c = theme.Footer) === null || _c === void 0 ? void 0 : _c.height,
      left: '50%',
      minHeight: 600,
      top: (_d = theme.Header) === null || _d === void 0 ? void 0 : _d.height,
      width: '100%'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.Body) === null || _e === void 0 ? void 0 : _e.fixed),
    maxWidth: {
      maxWidth: (_f = theme.Body) === null || _f === void 0 ? void 0 : _f.maxWidth
    },
    noHeader: {
      top: 0
    },
    noFooter: {
      bottom: 0
    }
  };
};

exports.style = style;